import { lazy, Suspense } from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import DashboardLayout from './layouts/dashboard';
import PublicLayout from './layouts/PublicLayout';
import AppLoader from './components/GeneralComponents/AppLoader';
import LandingContent from './components/portal/LandingContent';

const Dashboard = lazy(() => import('./pages/Dashboard/Dashboard'));
const LoginGate = lazy(() => import('./pages/Login/Login'));
const NotFound = lazy(() => import('./pages/NotFound'));
const ThemesPage = lazy(() => import('./pages/ThemesPage'));
const SitesList = lazy(() => import('./pages/Sites/SitesList'));
const NewSite = lazy(() => import('./pages/Sites/NewSite'));
const SiteOverview = lazy(() => import('./pages/Sites/SiteOverview'));
const ThemeSettings = lazy(() => import('./pages/Sites/ThemeSettings'));
const SitePagesPage = lazy(() => import('./pages/Sites/SitePagesPage'));
const SitePageEditorPage = lazy(() => import('./pages/Sites/SitePageEditorPage'));
const SiteMenusPage = lazy(() => import('./pages/Sites/SiteMenusPage'));
const SiteMenuEditorPage = lazy(() => import('./pages/Sites/SiteMenuEditorPage'));
const DomainSettings = lazy(() => import('./pages/Sites/DomainSettings'));
const SiteSettingsPage = lazy(() => import('./pages/Sites/SiteSettingsPage'));
const SiteSubmissionsPage = lazy(() => import('./pages/Sites/SiteSubmissionsPage'));
const SiteModulesPage = lazy(() => import('./pages/Sites/SiteModulesPage'));

const suspended = (element) => (
  <Suspense fallback={<AppLoader minHeight="40vh" size="medium" />}>{element}</Suspense>
);

const router = createBrowserRouter([
  {
    element: <DashboardLayout />,
    children: [
      { path: '/dashboard', element: suspended(<Dashboard />) },
      { path: '/themes', element: suspended(<ThemesPage />) },
      { path: '/sites', element: suspended(<SitesList />) },
      { path: '/sites/new', element: suspended(<NewSite />) },
      { path: '/sites/:siteId', element: suspended(<SiteOverview />) },
      { path: '/sites/:siteId/settings/theme', element: suspended(<ThemeSettings />) },
      { path: '/sites/:siteId/settings/domain', element: suspended(<DomainSettings />) },
      { path: '/sites/:siteId/settings', element: suspended(<SiteSettingsPage />) },
      { path: '/sites/:siteId/submissions', element: suspended(<SiteSubmissionsPage />) },
      { path: '/sites/:siteId/modules', element: suspended(<SiteModulesPage />) },
      { path: '/sites/:siteId/modules/:typeKey', element: suspended(<SiteModulesPage />) },
      { path: '/sites/:siteId/pages', element: suspended(<SitePagesPage />) },
      { path: '/sites/:siteId/pages/:pageId', element: suspended(<SitePageEditorPage />) },
      { path: '/sites/:siteId/pages/:pageId/modules', element: suspended(<SiteModulesPage />) },
      {
        path: '/sites/:siteId/pages/:pageId/modules/:typeKey',
        element: suspended(<SiteModulesPage />),
      },
      { path: '/sites/:siteId/menus', element: suspended(<SiteMenusPage />) },
      { path: '/sites/:siteId/menus/:menuId', element: suspended(<SiteMenuEditorPage />) },
    ],
  },
  {
    element: <PublicLayout />,
    children: [
      { path: '/', element: <LandingContent /> },
      { path: '/login', element: suspended(<LoginGate />) },
    ],
  },
  { path: '*', element: suspended(<NotFound />) },
]);

export default function Router() {
  return (
    <RouterProvider
      router={router}
      fallbackElement={<AppLoader minHeight="40vh" size="medium" />}
    />
  );
}
